<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在保存系统参数配置信息...">
      <a-row :gutter="{ xs: 8, sm: 16, md: 24}">
        <a-col :xs="0" :sm="0" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
        <a-col :xs="20" :sm="20" :md="18" :lg="18" :xl="18" :xxl="18">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="参数设置">
              <a-form :form="form" layout="horizontal">
                <a-table size="middle" :columns="columns" :scroll="{ x: '100%' }" row-key="code" :data-source="configs" :pagination="false">
                  <span slot="setting" slot-scope="text, record">
                    <a-form-item :colon="false" style="margin-bottom: 0px;">
                      <a-select v-if="record.formType == 'SELECT'" v-decorator="[`value${record.code}`, { rules: [{ required: true, message: '参数值必须选择!' }], initialValue: record.value }]" placeholder="请选择参数值" style="width: 150px;">
                        <a-select-option v-for="item in record.values" :key="(record.code+'-'+item.name)" :value="item.name">{{ item.value }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </span>
                </a-table>
              </a-form>
              <div class="button-container">
                <div>
                  <a-button icon="save" type="primary" style="float:right; margin-right: 24px;" @click="()=>saveConfig()">保存</a-button>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: "ParamConfig",
  data(){
    return {
      loading:false,
      form: this.$form.createForm(this),
      columns:[{
        title: '编码',
        key: 'code',
        dataIndex: 'code',
        align: 'center',
        width: 80,
        customRender:(text, record, index) =>{
          return text == null || text == undefined || text == '' ? '-' : text;
        }
      },
        {
          title: '参数名称',
          key: 'name',
          dataIndex: 'name',
          width: 200,
          customRender:(text, record, index) =>{
            return text == null || text == undefined || text == '' ? '-' : text;
          }
        },
        {
          title: '参数值',
          key: 'value',
          width: 160,
          scopedSlots: { customRender: 'setting' }
        },
        {
          title: '参数说明',
          key: 'desc',
          dataIndex: 'desc',
          customRender:(text, record, index) =>{
            return text == null || text == undefined || text == '' ? '-' : text;
          }
        }],
      configs:[]
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "基础设置",
      path: ""
    },{
      text: "参数设置",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.$axios.get('/api/clinic/config/ORGAN/params').then(function(res){
      if(res.msg.flag == 0 && null != res.biz){
        self.configs = res.biz;
      }else{
        self.configs = [];
      }
    },function(){
    });
  },
  methods: {
    saveConfig:function () {
      const self = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          let params=[];
          self.configs.forEach(function (e){
            params.push({code:e.code, value:values['value'+e.code]});
          });
          this.loading = true;
          this.$axios.post('/api/clinic/config/params/setting', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '系统参数设置保存成功', duration: 2});
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(){
            self.loading = false;
          });
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
